module.exports = __webpack_public_path__ + "img/approved-md.883c33a2.svg";